import React from 'react';

import { Path } from '~/paths';
import { ChapterWrapper } from '~/ChapterWrapper';
import Footer from '~/Footer';
import { ELink } from '~/ExternalLink';


const boxplot = require('../assets/images/boxplot.png');


export const BoxplotMeta = {
    title: "Boxplot (krabicový graf)",
    shortTitle: "Boxplot",
    path: Path.boxplot,
    element: (sectionNumber:string) => <Boxplot sectionNumber={sectionNumber}/>,
    sectionNumber: "",
}


export function Boxplot({sectionNumber}: {sectionNumber: string}) {

    return (
        <ChapterWrapper sectionNumber={sectionNumber} title={BoxplotMeta.title}>

            <p>
            Krabicový graf (boxplot, box-and-whisker plot) je tradiční (od r. 1970)
            způsob vizualizace dat, který kondenzovanou formou komunikuje základní
            představu o rozložení dat. Viz. např. <ELink href="https://cs.wikipedia.org/wiki/Boxplot">Wikipedie</ELink>.
            </p>

            <div style={{textAlign: "center", paddingBottom: 10}}>
                <img src={boxplot} style={{width: "100%"}}/>
            </div>
            <Footer/>
        </ChapterWrapper>
    );
}

